import { Box } from '@chakra-ui/react';

const Body1 = ({ children = null, ...rest }) => (
  <Box textStyle="body1" {...rest}>
    {children}
  </Box>
);

export default Body1;
